<template>
    <modal-component
        :visible="visible"
        id="claim-info-modal"
        @close="emitCloseModal()"
        size="lg"
        title="Submitting claims"
    >
        <div class="p-3">
            <div
                class="alert alert-warning alert-dismissible fade show mb-3"
                role="alert"
                v-if="claimError"
            >
                An error occurred when submitting your claim. <br />
                <button
                    class="btn btn-link text-warning mb-1 p-0"
                    @click="setShowInfoOnClaimFail(false)"
                >
                    Click here
                </button>
                if you don't want to see this message again.
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <template v-if="page === 1">
                <h4 class="text-muted">Set up your organization</h4>
                <ol class="my-3">
                    <li>On the side menu, go to "Control Center" and "Organization"</li>
                    <li>Fill your company's <b>Tax ID</b> and <b>NPI number</b> and save</li>
                </ol>
                <div class="d-flex justify-content-center align-items-center">
                    <img
                        src="../../../images/claim_organization.jpg"
                        alt="Stripe screenshot"
                        class="img-fluid"
                    />
                </div>
            </template>
            <template v-if="page === 2">
                <h4 class="text-muted">Set up your organization (continued)</h4>
                <ol class="my-3">
                    <li>Still in the "Control Center", go to "My Centers"</li>
                    <li>Click "EDIT" in the "Center location, hours & calendar details" section</li>
                    <li>Enter at least one complete center address and save</li>
                </ol>
                <img
                    src="../../../images/claim_organization_2.jpg"
                    alt="Stripe screenshot"
                    class="img-fluid"
                />
            </template>
            <template v-if="page === 3">
                <h4 class="text-muted">Set up your patient</h4>
                <ol class="my-3">
                    <li>Go to your patient's profile page in "Patients"</li>
                    <li>Click "EDIT" in the first section, with the patient name</li>
                    <li>
                        Make sure to fill <b>Date of Birth</b>, <b>Gender</b> and a complete
                        <b>Home Address</b> and save
                    </li>
                </ol>
                <img
                    src="../../../images/claim_patient.jpg"
                    alt="Stripe screenshot"
                    class="img-fluid"
                />
            </template>
            <template v-if="page === 4">
                <h4 class="text-muted">
                    Set up your therapist (optional, when therapist is the rendering provider)
                </h4>
                <span
                    >If you picked a therapist and chose to override the company NPI when creating a
                    funding:</span
                >
                <ol class="mb-3">
                    <li>Go to the therapist's profile page in "Staff"</li>
                    <li>Click "EDIT" in the "Clinic information" section</li>
                    <li>Fill the <b>NPI number</b> field and save</li>
                </ol>
                <img
                    src="../../../images/claim_therapist.jpg"
                    alt="Stripe screenshot"
                    class="img-fluid"
                />
            </template>
            <div class="my-3">
                <toggle-button
                    :value="!!showInfoOnClaimFail"
                    color="#D64571"
                    @change="setShowInfoOnClaimFail($event.value)"
                    :sync="true"
                    :labels="true"
                />
                <span class="ml-3">Show this when a claim submission fails </span>
            </div>
            <div class="w-100 d-flex justify-content-between align-items-center ">
                <button
                    class="btn btn-link text-primary"
                    @click="page > 1 ? page-- : null"
                    :disabled="page === 1"
                >
                    Previous tip
                </button>
                <button
                    class="btn btn-primary"
                    @click="page < 4 ? page++ : null"
                    :disabled="page === 4"
                >
                    Next tip
                </button>
            </div>
        </div>
    </modal-component>
</template>

<script>
import ModalComponent from "../ui/ModalComponent";
export default {
    name: "ClaimInfo",
    props: ["isVisible", "claimError"],
    components: {
        ModalComponent,
    },
    data() {
        return {
            page: 1,
            showInfoOnClaimFail: 1,
        };
    },
    mounted() {
        switch (window.localStorage.getItem("showInfoOnClaimFail")) {
            case 1:
                this.showInfoOnClaimFail = 1;
                break;
            case 0:
                this.showInfoOnClaimFail = 1;
                break;
            case null:
                window.localStorage.setItem("showInfoOnClaimFail", 1);
                this.showInfoOnClaimFail = 1;
        }
    },
    watch: {
        isVisible() {
            if (!this.showInfoOnClaimFail) {
                this.emitCloseModal();
            }
        },
    },
    computed: {
        visible() {
            if (this.claimError) {
                return this.isVisible && this.showInfoOnClaimFail;
            }
            return this.isVisible;
        },
    },
    methods: {
        emitCloseModal() {
            this.$emit("close-modal");
        },
        setShowInfoOnClaimFail(value) {
            if (value) {
                window.localStorage.setItem("showInfoOnClaimFail", 1);
                this.showInfoOnClaimFail = 1;
            } else {
                window.localStorage.setItem("showInfoOnClaimFail", 0);
                this.showInfoOnClaimFail = 0;
            }
        },
    },
};
</script>

<style scoped></style>
